import { render, staticRenderFns } from "./BtnReportInvoiceData.yaml?vue&type=template&id=5be5707a&component"
import script from "./BtnReportInvoiceData.yaml?vue&type=script&lang=ts&component"
export * from "./BtnReportInvoiceData.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports